import { render, staticRenderFns } from "./KpiCollectionEmpty.vue?vue&type=template&id=0832e923&scoped=true&"
import script from "./KpiCollectionEmpty.vue?vue&type=script&lang=js&"
export * from "./KpiCollectionEmpty.vue?vue&type=script&lang=js&"
import style0 from "./KpiCollectionEmpty.vue?vue&type=style&index=0&id=0832e923&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0832e923",
  null
  
)

export default component.exports